import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import DashboardLayout from "../../components/DashboardLayout";
import ModalRoute from "../../components/common/ModalRoute";
import Account from "./Account";
import Billing from "./Billing";
import Features from "./Features";
import Preferences from "./Preferences";
import SubscriptionCancel from "./SubscriptionCancel";
import TransferSite from "./TransferSite";

const ComingSoon = ({ title }) => (
  <div className="max-w-xl rounded-xl border border-dashed border-theme-secondary p-10 text-center">
    <h2 className="font-bold">{title}</h2>
    <p className="mt-2 text-sm opacity-60">This account feature is coming soon.</p>
  </div>
);

const AccountIndex = (authProps) => {
  const location = useLocation();
  const tabs = ["profile", "billing", "features", "team", "preferences"];
  const active = tabs.find((tab) => location.pathname.includes(`/${tab}/`)) || "profile";
  const navConfig = tabs.map((tab) => ({
    id: tab,
    label: tab[0].toUpperCase() + tab.slice(1),
    to: `/account/${tab}/`,
    active: active === tab,
  }));

  return (
    <DashboardLayout title="Account" currentUser={authProps.currentUser} navConfig={navConfig}>
      <Routes>
        <Route path="profile" element={<Account {...authProps} />} />
        <Route path="billing/*" element={<Billing {...authProps} />} />
        <Route path="features" element={<Features {...authProps} />} />
        <Route path="gifts" element={<Navigate to="/invites/" replace />} />
        <Route path="team" element={<ComingSoon title="Team" />} />
        <Route path="preferences" element={<Preferences />} />
        <Route path="" element={<Navigate to="profile/" replace />} />
        <Route path="*" element={<Navigate to="profile/" replace />} />
      </Routes>
      <ModalRoute
        path="/account/billing/cancel"
        parentPath="/account/billing/"
        element={<SubscriptionCancel />}
        maxWidth="max-w-lg"
        heightClass="h-auto max-h-[90vh]"
        noPadding
      />
      <ModalRoute
        path="/account/billing/transfer"
        parentPath="/account/billing/"
        element={<TransferSite />}
        maxWidth="max-w-lg"
        heightClass="h-auto max-h-[90vh]"
        noPadding
      />
    </DashboardLayout>
  );
};

export default AccountIndex;
